var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbtcTokenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.042 39.741c-4.274 17.143-21.64 27.576-38.786 23.301C7.116 58.768-3.318 41.404.959 24.262 5.23 7.118 22.596-3.316 39.738.958c17.145 4.274 27.579 21.64 23.304 38.783z",
    fill: "#F7931A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.966 4.38l24.07 13.896V46.07l-24.07 13.897-24.07-13.897V18.276L31.966 4.38z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.919 28.08c.645-4.202-2.638-6.462-7.127-7.969l1.456-5.694-3.555-.863-1.417 5.543c-.935-.227-1.895-.441-2.849-.653l1.428-5.58L31.302 12l-1.458 5.692c-.773-.172-1.533-.342-2.27-.52l.004-.018-4.903-1.194-.946 3.702s2.638.59 2.582.626c1.44.35 1.7 1.279 1.657 2.015L24.31 28.79c.1.025.228.06.37.116-.118-.029-.245-.06-.376-.09L21.978 37.9c-.176.427-.622 1.066-1.629.824.036.05-2.584-.63-2.584-.63L16 42.063l4.627 1.124c.86.21 1.704.43 2.534.638l-1.471 5.759 3.551.863 1.457-5.697c.97.256 1.912.493 2.834.716l-1.453 5.671 3.556.864 1.471-5.748c6.063 1.118 10.621.667 12.54-4.678 1.546-4.303-.077-6.786-3.267-8.405 2.323-.522 4.073-2.011 4.54-5.088zm-8.123 11.105c-1.099 4.303-8.532 1.977-10.942 1.393l1.952-7.629c2.41.586 10.138 1.747 8.99 6.236zm1.1-11.166c-1.003 3.914-7.19 1.925-9.197 1.438l1.77-6.92c2.007.488 8.47 1.398 7.426 5.482z",
    fill: "#F7931A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbtcTokenLogo);
export default __webpack_public_path__ + "static/media/abtc-token-logo.2dc7b9f3a3b345c322d7c672e0bc619b.svg";
export { ForwardRef as ReactComponent };